import React from 'react';
import { Typography } from '@mui/material';

export const GameBasicInfo = ({ gameData, isSingleGame }) => {
    const displayData = isSingleGame ? {
        gameName: gameData?.game?.gameName,
        launchID: gameData?.game?.launchID,
        moduleId: gameData?.game?.moduleId,
        clientId: gameData?.game?.clientId,
        GameflexGameID: gameData?.game?.GameflexGameID,
    } : {
        gameName: gameData?.gameName || gameData?.displayTitle,
        launchID: gameData?.launchID,
        moduleId: gameData?.moduleId,
        clientId: gameData?.clientId,
        GameflexGameID: gameData?.GameflexGameID,
    };

    return (
        <div className="details-group">
            <Typography variant="h6" className="section-title">Basic Information</Typography>
            <div className="details-grid">
                <Typography variant="body1">Game Name: {displayData.gameName || 'N/A'}</Typography>
                <Typography variant="body1">Launch ID: {displayData.launchID || 'N/A'}</Typography>
                <Typography variant="body1">Module ID: {displayData.moduleId || 'N/A'}</Typography>
                <Typography variant="body1">Client ID: {displayData.clientId || 'N/A'}</Typography>
                <Typography variant="body1">GameFlex ID: {displayData.GameflexGameID || 'N/A'}</Typography>
            </div>
        </div>
    );
};